<div>
  <nx-pageTitle-box
    [label]="'Nutzer'+ (this.creationMode? ' anlegen': ' bearbeiten') "
    [bcRootLvlLabel]="'Nutzer'"
    [bcRootLvlPath]="'settings/users'"
    [icon]="'icon-person'"
    [iconToolTip]=""></nx-pageTitle-box>
<div class="body flex flex-col white">
  <div class="flex flex-row basis-full justify-end">
    <mat-slide-toggle
    *ngIf="!this.creationMode"
    [checked]="user?.enabled"
    (change)="user?.enabled ? suspendUser() : unsuspendUser()">
      Nutzer {{user?.enabled ? 'aktiv' : 'inaktiv'}}
    </mat-slide-toggle>
  </div>
  <h3 class="basis-full">Profil</h3>
  <div [formGroup]="profileFormGroup" class="flex flex-col basis-1/4">
    <div class="flex flex-row basis-full space-x-4">
      <mat-form-field class="basis-1/2">
        <mat-error *ngIf="profileFormGroup.get('email')?.hasError('emailExists')">
          E-Mail-Adresse vergeben.
        </mat-error>
        <mat-error *ngIf="profileFormGroup.get('email')?.hasError('pattern')">
          Bitte gib eine gültige E-Mai-Adresse ein.
        </mat-error>
        <mat-label>E-Mail/Login</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>
      <mat-form-field class="basis-1/2">
        <mat-label>Kürzel</mat-label>
        <input matInput formControlName="initials">
      </mat-form-field>
    </div>

    <div class="flex flex-row basis-full space-x-4">
      <mat-form-field class="basis-1/2">
        <mat-label>Vorname</mat-label>
        <input matInput formControlName="firstName">
      </mat-form-field>
      <mat-form-field class="basis-1/2">
        <mat-label>Nachname</mat-label>
        <input matInput formControlName="lastName">
      </mat-form-field>
    </div>
    <div class="flex flex-row basis-full">
      <div class="basis-full">
        <mat-form-field class="full-width ">
          <mat-label>Rollen</mat-label>
          <mat-select multiple="true" formControlName="roles">
            <mat-option *ngFor="let role of roles" [value]="role.name">
              {{ role.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-row basis-full gap-25">
      <div class="basis-full">
        <mat-form-field class="full-width ">
          <mat-label>Gruppen</mat-label>
          <mat-select multiple="true" formControlName="groups">
            <mat-option *ngFor="let group of groups" [value]="group.id">
              {{ group.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="flex flex-row basis-full">
      <div class="basis-full">
        <mat-form-field class="full-width ">
          <mat-label>Niederlassungen</mat-label>
          <mat-select multiple="true" formControlName="locationIds">
            <mat-option *ngFor="let location of locations" [value]="location.id">
              {{ location.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="flex basis-full gap-25 start" *ngIf="!creationMode">
    <button mat-flat-button *ngIf="profileFormGroup.disabled" (click)="editProfile()" color="primary"
      [disabled]="credentialsFormGroup.enabled || licenceFormGroup?.enabled" class="large-button">Profil bearbeiten</button>
    <button mat-flat-button *ngIf="profileFormGroup.enabled" (click)="updateProfile()" color="primary"
      [disabled]="!(profileFormGroup.valid && !profileFormGroup.pristine)">Speichern</button>
    <button mat-flat-button *ngIf="profileFormGroup.enabled" (click)="abortEditProfile()" color="primary">Abbrechen</button>
  </div>
  <!-- <h3 fxFlex="100%">Berechtigungen</h3>
  <div fxLayout='row' fxLayoutGap="25px" [formGroup]="authoritiesFormGroup">
    <div fxFlex="calc(50%-25px)">
      <mat-form-field class="full-width">
        <mat-select placeholder="Gruppen" multiple="true" formControlName="groups">
          <mat-option *ngFor="let group of groups" [value]="group.id">
            {{ group.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div fxFlex="calc(50%-25px)"></div>
  </div> -->
  <!-- <div fxFlex="100%" fxLayout='row' fxLayoutGap="25px" fxLayoutAlign="end start" *ngIf="!creationMode">
    <button *ngIf="authoritiesFormGroup.enabled" mat-flat-button (click)="abortEditAuthorities()">Abbrechen</button>
    <button *ngIf="authoritiesFormGroup.enabled" mat-flat-button (click)="updateRoles()"
    [disabled]="!(authoritiesFormGroup.valid && !authoritiesFormGroup.pristine)">Speichern</button>
    <button *ngIf="!authoritiesFormGroup.enabled" mat-flat-button (click)="editAuthorities()"
      [disabled]="credentialsFormGroup.enabled || profileFormGroup.enabled">Gruppen ändern</button>
  </div> -->
  <h3 class="basis-full">Passwort</h3>
  <div [formGroup]="credentialsFormGroup" class="basis-full flex flex-col gap-25">
    <div class="flex-row gap-25">
      <mat-form-field class="full-width">
        <mat-error *ngIf="credentialsFormGroup.get('password')?.hasError('minlength')">
          Das Passwort muss mindestens 5 Zeichen haben.
        </mat-error>
        <mat-label>Passwort</mat-label>
        <input matInput type="password" formControlName="password">
      </mat-form-field>
    </div>
    <div class="flex-row gap-25">
      <mat-checkbox formControlName="updatePassword">
        Nutzer muss Passwort bei der nächsten Anmeldung ändern
      </mat-checkbox>
    </div>
  </div>
  <div class="flex basis-full gap-25 start" *ngIf="!this.creationMode">
    <button mat-flat-button *ngIf="!credentialsFormGroup.enabled" (click)="changePassword()" color="primary"
      [disabled]="profileFormGroup?.enabled || licenceFormGroup?.enabled">Passwort bearbeiten</button>
    <button mat-flat-button *ngIf="credentialsFormGroup.enabled" (click)="resetPassword()" color="primary"
      [disabled]="!(credentialsFormGroup.valid && !credentialsFormGroup.pristine)">Speichern</button>
    <button mat-flat-button *ngIf="credentialsFormGroup.enabled" (click)="abortChangePassword()" color="primary">Abbrechen</button>
  </div>
  <!-- <h3 fxFlex="100%" *ngIf="!this.creationMode">Fahrten</h3>
  <div fxLayout="row" fxFlex="100%" fxLayoutAlign="end" *ngIf="!this.creationMode">
    <mat-form-field class="calendar">
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate #start placeholder="Start" [(ngModel)]="startLog" (dateChange)="startUpdated(start.value)">
        <input matEndDate #end placeholder="Ende" [(ngModel)]="endLog" (dateChange)="endUpdated(end.value)">
      </mat-date-range-input>
      <i [className]="'icon icon-calendar'" tabindex="-1" (click)="picker.open()"></i>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div> -->
  <!-- <div fxLayout="row" fxFlex="100%" *ngIf="!this.creationMode">
    <app-log-book type="user" [log]="user? user.id : ''" [startLog]="startLog" [endLog]="endLog" class="full-width"></app-log-book>
  </div> -->
  <h3 class="basis-full" *ngIf="!this.creationMode">Lizenz</h3>
  <div [formGroup]="licenceFormGroup" class="basis-full flex flex-col gap-25" *ngIf="!this.creationMode">
    <div class="flex flex-row basis-full gap-25">
      <div class="basis-full">
        <mat-form-field class="full-width ">
          <mat-label>Lizenz</mat-label>
          <mat-select  formControlName="licenceType">
            <ng-container *ngIf="!env?.stripeEnabled  || !tenant?.paymentProviderEnabled">
              <mat-option *ngFor="let licenceType of licenceTypes" [value]="licenceType.name">
                {{ licenceType.label }}
              </mat-option>
            </ng-container>
            <ng-container *ngIf="env?.stripeEnabled && tenant?.paymentProviderEnabled">
              <mat-option *ngFor="let licence of licenceInfo" [value]="licence.type" [disabled]="!licence?.assignable">
                <!-- {{ User.getLicenceType(licence.type) }} ({{licence.open}}) -->
              </mat-option>
              <mat-option value="NO_LICENCE">
                Keine Lizenz
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="flex basis-full gap-25 start" *ngIf="!this.creationMode">
    <button mat-flat-button *ngIf="!licenceFormGroup.enabled" (click)="changeLicence()" color="primary"
      [disabled]="credentialsFormGroup.enabled || profileFormGroup?.enabled">Lizenz bearbeiten</button>
    <button mat-flat-button *ngIf="licenceFormGroup.enabled" (click)="resetLicence()" color="primary"
      [disabled]="!(licenceFormGroup.valid && !licenceFormGroup.pristine)">Speichern</button>
    <button mat-flat-button *ngIf="licenceFormGroup.enabled" (click)="abortLicence()" color="primary">Abbrechen</button>
  </div>
  <div class="flex basis-full gap-25 start" *ngIf="this.creationMode">
    <button mat-flat-button (click)="createUser()" color="primary"
      [disabled]="!(profileFormGroup.valid && !profileFormGroup.pristine)">Speichern</button>
    <button mat-flat-button (click)="abort()" color="primary">Abbrechen</button>
  </div>
</div>
</div>
